export default __webpack_public_path__ + "static/media/erc.65999b36.png";